module.exports = __webpack_public_path__ + "img/front length from HPS to empire seam.e712dabf.png";